import { BoxProps } from '@mui/material/Box';
import { Theme } from '@mui/material/styles';

import { DescriptionStyles } from './types';

/**
 * Default wrapper props for the TitleSection component
 */
export const DEFAULT_WRAPPER_PROPS: BoxProps = {
  mb: 4,
  pl: 4,
  pr: 4,
};

/**
 * Default component type for title element
 */
export const DEFAULT_TITLE_COMPONENT = 'div';

/**
 * Creates CommandBar-specific styles when CommandBar is enabled
 *
 * @param {boolean} isCommandBarEnabled - Whether CommandBar is enabled
 * @returns {object} CommandBar styles object
 */
export const createCommandBarStyles = (isCommandBarEnabled: boolean): object => {
  if (!isCommandBarEnabled) {
    return {};
  }

  return {
    display: 'inline-block',
    width: 'fit-content',
    color: 'primary.main',
  };
};

/**
 * Creates description styles using theme values
 *
 * @param {Theme} theme - Material-UI theme object
 * @returns {DescriptionStyles} Description styles object
 */
export const createDescriptionStyles = (theme: Theme): DescriptionStyles => ({
  fontSize: theme.typography.pxToRem(14),
  fontWeight: theme.typography.fontWeightRegular as number,
  color: 'darkGrey.main',
});

/**
 * Gets default font size from theme
 *
 * @param {Theme} theme - Material-UI theme object
 * @param {number | string} [customFontSize] - Optional custom font size override
 * @returns {number | string} Font size value
 */
export const getDefaultFontSize = (theme: Theme, customFontSize?: number | string): number | string =>
  customFontSize ?? theme.typography.pxToRem(20);

/**
 * Gets default font weight from theme
 *
 * @param {Theme} theme - Material-UI theme object
 * @param {number | string} [customFontWeight] - Optional custom font weight override
 * @returns {number | string} Font weight value
 */
export const getDefaultFontWeight = (theme: Theme, customFontWeight?: number | string): number | string =>
  customFontWeight ?? (theme.typography.fontWeightMedium as number);
